module.exports = __webpack_public_path__ + "media/images/icon-unidentified@3x-c36725221fccbff5bae860e89919f266.png";